/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lone-blocks */
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { onMemberPost } from "../../Store/Slices/memberSlice";
import Cookies from "js-cookie";
import {
  onGenerateTokenSubmit,
  onGenerateTokenSubmitReset,
} from "../../Store/Slices/generateTokenSlice";
import {
  onValidateLoginTokenReset,
  onValidateLoginTokenSubmit,
} from "../../Store/Slices/validateLoginTokenSlice";
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import axiosIntegrationOtp from "../../Common/Axios/axiosIntegrationOtp";
import {
  onGetMember,
  onGetMemberReset,
} from "../../Store/Slices/getMemberSlice";
import API from "../../Common/Endpoint/serviceConstrants";
import { onSavePoints } from "../../Store/Slices/cardDataSlice";
import Loader from "../../Components/Loader/Loader";
import { trackEvent } from "../../Components/Utility/Utility";

const TempPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const [accountData, setAccountData] = useState([]);
  const [isApiCallsDone, setIsApiCallsDone] = useState(false);
  const hasHandledNavigation = useRef(false); // Prevent multiple redirects
  const hasCalledValidateToken = useRef(false); // Prevent multiple validateLoginToken calls

  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const generateToken = useSelector((state) => state.generateTokenSliceReducer);
  const loginToken = useSelector(
    (state) => state.validateLoginTokenSliceReducer
  );
  const currentBalance = useSelector((state) => state.cardDataSliceReducer?.pointBalance);
  const V3Data = useSelector((state) => state.cardDataSliceReducer);

  const memberData = useSelector((state) => state.getMemberSliceReducer);
  const cards =
    memberData?.MemberData?.otherListAttribute?.[0]?.valueDetails?.filter(
      (cardData) => cardData.status !== "0"
    );

  const loginTokenData = loginToken.data;
  const urlIndex = location.pathname.split("/");
  const callSwitchAccountApi = async (payload) => {
    try {
      const { data = [] } = await axiosIntegration.post(
        API.switchAccountApi,
        payload
      );
      setAccountData((prevData) => [...prevData, data]);
      return data;
    } catch (error) { }
  };

  // Handle back button detection
  useEffect(() => {
    if (sessionStorage.getItem("login") === 'true' && localStorage.getItem("ProductListPage_back")) {
      hasHandledNavigation.current = true;
      const redirectPath = localStorage.getItem("ProductListPage_back") || "/";
      navigate(redirectPath, { replace: true });
      return;
    }
  }, [navigate]);

  useEffect(() => {
    sessionStorage.removeItem("login");
  }, []);


  useEffect(() => {
    sessionStorage.setItem("loginSessionToken", urlIndex[2]);
    sessionStorage.setItem("temporaryToken", urlIndex[3]);
    const { accessKey, secrateKey, partnerCode, ClientCode } = V3Data || {};
    if (
      accessKey &&
      secrateKey &&
      partnerCode &&
      ClientCode &&
      !sessionStorage.getItem("login")
    ) {
      dispatch(
        onGenerateTokenSubmit({
          accessKey,
          secrateKey,
          partnerCode,
          ClientCode,
        })
      );
    }
  }, [V3Data]);

  useEffect(() => {
    if (generateToken?.status_code === 200) {
      axiosIntegration.defaults.headers[
        "access-token"
      ] = `${generateToken?.data?.accessToken}`;
      axiosIntegration.defaults.headers["ClientCode"] = `${V3Data.ClientCode}`;
      axiosIntegration.defaults.headers[
        "partnerCode"
      ] = `${V3Data.partnerCode}`;

      axiosIntegrationOtp.defaults.headers[
        "access-token"
      ] = `${generateToken?.data?.accessToken}`;
      if (!hasCalledValidateToken.current) {
        hasCalledValidateToken.current = true;
        dispatch(
          onValidateLoginTokenSubmit({
            loginSessionToken: sessionStorage.getItem("loginSessionToken"),
            integrationSecretKey: V3Data?.integrationSecretKey,
            temporaryToken: sessionStorage.getItem("temporaryToken"),
            urlReferrer: "",
            ClientCode: V3Data?.ClientCode,
            partnerCode: V3Data?.partnerCode,
          })
        );
      }
      dispatch(onGenerateTokenSubmitReset());
    }
  }, [generateToken]);

  useEffect(() => {
    if (loginToken.status_code === "200") {
      sessionStorage.setItem("login", true);
      if (loginToken.data?.isNewMember === false) {
        trackEvent("login", {
          method: "sso",
          first_name: loginTokenData?.memberProfile?.firstName || "F",
          last_name: loginTokenData?.memberProfile?.lastName || "L",
          email: loginTokenData?.memberProfile?.emailId || "",
          phone: loginTokenData?.memberProfile?.mobileNumber || "",
          Xid: Cookies.get('xid') || "",
        });
      }
      else {
        trackEvent("sign_up", {

          method: "sso",
          first_name: loginTokenData?.memberProfile?.firstName || "F",
          last_name: loginTokenData?.memberProfile?.lastName || "L",
          email: loginTokenData?.memberProfile?.emailId || "",
          phone: loginTokenData?.memberProfile?.mobileNumber || "",
          Xid: Cookies.get('xid') || "",
        });
      }
      dispatch(onGetMember(loginToken));
      if (loginTokenData?.customerAddUpdate) {
        dispatch(
          onMemberPost({
            memberId: loginTokenData.memberIdentifier,
            firstName: loginTokenData?.memberProfile?.firstName,
            lastName: loginTokenData?.memberProfile?.lastName,
            emailId: loginTokenData?.memberProfile?.emailId,
            mobileNumber: loginTokenData?.memberProfile?.mobileNumber,
            clientId: loginAuthData?.data?.[0]?.clientId,
            dob: loginTokenData?.memberProfile?.dob,
            gender: loginTokenData?.memberProfile?.genderDescription,
          })
        );
      }


      dispatch(onValidateLoginTokenReset());
    }
  }, [loginToken]);

  useEffect(() => {
    if (memberData?.get_status_code === "200" && memberData?.MemberData) {
      // dispatch(
      //   onSavePoints({
      //     points: Math.round(
      //       memberData?.MemberData?.memberBalance?.[0]?.pointBalance
      //     ),
      //     identifierType: creditCards?.[0]?.identifierType,
      //     subIdentifier: creditCards?.[0]?.subIdentifier,
      //     pointBalance: res?.response?.memberBalance?.pointBalan
      //   })
      // );

      if (!cards || cards.length === 0) {
        callSwitchAccountApi({
          identifier: memberData?.MemberData.memberIdentifier,
          subIdentifier: memberData?.MemberData.subIdentifier,
          identifierType: memberData?.MemberData?.subIdentifierType === null ? 1001 : memberData?.MemberData?.subIdentifierType,
          userSessionToken: sessionStorage.getItem("loginSessionToken"),
          isAccountSwitch: false,
        }).then((res) => {

          dispatch(
            onSavePoints({
              pointBalance: res?.response?.memberBalance?.pointBalance ?? memberData?.MemberData?.memberBalance?.[0]?.pointBalance,
              identifierType: creditCards?.[0]?.identifierType,
              subIdentifier: creditCards?.[0]?.subIdentifier,
            })
          );
          setIsApiCallsDone(true);
          dispatch(onGetMemberReset());
        });
        // setIsApiCallsDone(true);
        // dispatch(onGetMemberReset());
        return;
      }

      const cardPromises = cards.map((cardData) =>
        callSwitchAccountApi({
          identifier: memberData?.MemberData.memberIdentifier,
          // subIdentifier: memberData?.MemberData.memberIdentifier || cardData?.identifier,
          subIdentifier: memberData?.MemberData.subIdentifier,
          identifierType: memberData?.MemberData?.subIdentifierType === null ? 1001 : memberData?.MemberData?.subIdentifierType,
          userSessionToken: sessionStorage.getItem("loginSessionToken"),
          isAccountSwitch: false,
        })
      )

      Promise.all(cardPromises).then(() => {
        setIsApiCallsDone(true);
        dispatch(onGetMemberReset());
      });
    }
  }, [memberData]);

  const mergedArray = useMemo(
    () =>
      accountData
        .map((cardData) => cardData.response)
        ?.map((item1) => {
          const matchingItem = cards?.find(
            (item2) => item2.identifier === item1.subIdentifier
          );
          return {
            ...item1,
            ...(matchingItem ? { cardDetails: matchingItem } : {}),
          };
        }),
    [cards]
  );

  const creditCards = useMemo(
    () =>
      mergedArray?.filter(
        (card) => card?.cardDetails?.identifiertype === "1002"
      ),
    [mergedArray]
  );

  useEffect(() => {
    if (isApiCallsDone && !hasHandledNavigation.current) {
      const arrayData = sessionStorage.getItem("arrayData");

      if (localStorage.getItem("ProductListPage")) {
        if (localStorage.getItem("ProductListPage") === "/order-detail") {
          navigate("/orders", { replace: true });
        } else {
          if (arrayData) {
            const parsedArrayData = JSON.parse(arrayData);
            navigate(localStorage.getItem("ProductListPage"), {
              state: { arrayData: parsedArrayData },
              replace: true,
            });
            sessionStorage.removeItem("arrayData");
          } else {
            navigate(localStorage.getItem("ProductListPage"), { replace: true });
          }
        }
        localStorage.removeItem("ProductListPage");
      } else {
        if (arrayData) {
          sessionStorage.removeItem("arrayData");
        }
        navigate("/", { replace: true });
      }

      sessionStorage.setItem(
        "accountData",
        JSON.stringify(accountData.map((cardData) => cardData.response))
      );
      {
        cards && sessionStorage.setItem("cardInfo", JSON.stringify(cards));
      }
    
    }
  }, [isApiCallsDone, navigate]);

  return (
    <>
      <Loader />
    </>
  );
};

export default TempPage;